import Vue from 'vue'
import Vuex from 'vuex'
import auth from './../modules/auth/store'
import localforage from 'localforage'
import CartService from './../services/cart.service'
import SaleService from './../services/sale.service'
import BannerService from './../services/banner.service'
import VehicleService from '../services/vehicle.service'
import ConfigService from '@/services/config.service'
import { map } from 'lodash'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth: auth
  },
  state: {
    layout: 'login-layout',
    modeLabel: 'Aktiv',
    customerTypeLabel: 'Händler',
    modePriceLabel: 'VK-Preis',
    showEndcustomerPrices: false,
    showMerchantPrices: false,
    mode: 'merchant',
    customerType: 'merchant',
    cartCount: 0,
    cartItems: [],
    stats: {},
    tenant: {},
    banners: [],
    makes: [],
    config: {},
    merchantConfig: {
      general: {hideImages: false}
    }
  },
  mutations: {
    SET_LAYOUT(state, layout) {
      state.layout = layout
    },
    SET_MODE(state, mode) {
      state.mode = mode
    },
    SET_CUSTOMER_TYPE(state, type) {
      state.customerType = type
    },
    SET_CART_COUNT(state, count) {
      state.cartCount = count
    },
    SET_CART(state, items) {
      state.cartItems = items
    },
    SET_STATS(state, stats) {
      state.stats = stats
    },
    SET_TENANT(state, tenant) {
      state.tenant = tenant
    },
    SET_BANNERS(state, banners) {
      state.banners = banners
    },
    SET_MAKES(state, makes) {
      state.makes = makes
    },
    SET_CONFIG(state, config) {
      state.config = config
    },
    SET_MERCHANT_CONFIG(state, config) {
      state.merchantConfig = config
    }
  },
  getters: {
    layout(state) {
      return state.layout
    },
    mode(state) {
      return state.mode
    },
    customerType(state) {
      return state.customerType
    },
    modeLabel(state) {
      return state.mode === 'merchant' ? 'Zur Verkaufsansicht wechseln' : 'Zur Einkaufsansicht wechseln'
    },
    customerTypeLabel(state) {
      return state.customerType === 'endcustomer' ? 'Endverbaucher' : 'Händler'
    },
    modePriceLabel(state) {
      if (
        Object.keys(state.tenant).length &&
        (state.tenant.knumber === 'K10122' || state.tenant.knumber === 'K10151')
      ) {
        return state.mode == 'merchant' ? 'Händler-Einkaufspreis' : 'Kalkulierter Endkundenpreis'
      }
      return state.mode == 'merchant' ? 'B2B-EK' : 'VK-Preis'
    },
    showEndcustomerPrices(state) {
      return state.mode == 'endcustomer' && state.customerType == 'endcustomer'
    },
    showMerchantPrices(state) {
      return state.mode == 'endcustomer' && state.customerType == 'merchant'
    },
    cartCount(state) {
      return state.cartCount
    },
    cartItems(state) {
      return state.cartItems
    },
    stats(state) {
      return state.stats
    },
    tenant(state) {
      return state.tenant
    },
    banners(state) {
      return state.banners
    },
    makes(state) {
      return state.makes
    },
    config(state) {
      return state.config
    },
    merchantConfig(state) {
      return state.merchantConfig
    }
  },
  actions: {
    getMode({ commit }) {
      localforage.getItem('mode').then(mode => {
        if (mode) {
          commit('SET_MODE', mode)
        }
      })
    },
    getCustomerType({ commit }) {
      localforage.getItem('customerType').then(type => {
        if (type) {
          commit('SET_CUSTOMER_TYPE', type)
        }
      })
    },
    switchMerchantMode({ commit, state }) {
      const mode = state.mode === 'merchant' ? 'endcustomer' : 'merchant'

      commit('SET_MODE', mode)
      commit('SET_CUSTOMER_TYPE', 'endcustomer')
      localforage.setItem('mode', mode)
    },
    switchCustomerType({ commit, state }) {
      const customerType = state.customerType === 'merchant' ? 'endcustomer' : 'merchant'
      commit('SET_CUSTOMER_TYPE', customerType)
      localforage.setItem('customerType', customerType)
    },
    getCartCount({ commit }) {
      CartService.getCount().then(response => {
        commit('SET_CART_COUNT', response.data)
      })
    },
    getCart({ commit }) {
      CartService.get().then(response => {
        commit('SET_CART', response.data.data)
      })
    },
    getMakes({ commit }, params) {
      VehicleService.getMakes(params).then(response => {
        commit('SET_MAKES', response.data)
      })
    },
    getStats({ commit }, params) {
      SaleService.getStats(params).then(response => {
        commit('SET_STATS', response.data)
      })
    },
    getVehicleCount({ commit }, params) {
      SaleService.getVehicleCount(params).then(response => {
        commit('SET_STATS', response.data)
      })
    },
    getBanners({ commit }) {
      BannerService.get().then(response => {
        commit('SET_BANNERS', response.data)
      })
    },
    getConfig({ commit }) {
      let config = {}
      ConfigService.get().then(response => {
        map(response.data, c => {
          config[c.configKey] = c.configValue
        })
      })
      commit('SET_CONFIG', config)
    },
    getMerchantConfig({ commit, state }) {
      ConfigService.getMerchantConfig().then(response => {
        if(response.data.configValue) {
          const config = Object.assign(state.merchantConfig, response.data.configValue)
          commit('SET_MERCHANT_CONFIG', config)
        }
      })
    }
  }
})
